import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { NavigationAuthenticationClient } from './utils/NavigationAuthenticationClient';
import { msalConfig } from './authConfig';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

config({ licenseKey });

// StatusBar-Konfiguration für native Plattformen
const configureStatusBar = async () => {
    if (Capacitor.isNativePlatform()) {
        try {
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setBackgroundColor({ color: '#0d3ec5' }); // Ändern Sie diese Farbe nach Ihren Wünschen
            await StatusBar.setStyle({ style: Style.Dark }); // Style.Light oder Style.Dark
            console.log('StatusBar configured successfully');
        } catch (error) {
            console.error('StatusBar configuration failed:', error);
        }
    }
};

// StatusBar konfigurieren
configureStatusBar();

export const msalInstance = new PublicClientApplication(msalConfig);
console.log('MSAL instance created:', JSON.stringify(msalConfig));
msalInstance.initialize().then(() => {
    msalInstance.handleRedirectPromise().then((tokenResponse) => {

        console.log('MSAL initialized successfully in index.js:', tokenResponse);
        if (tokenResponse && tokenResponse.account) {
            console.log('Redirect response received in index.js:', tokenResponse);
            msalInstance.setActiveAccount(tokenResponse.account);
        }
    }).catch((error) => {
        console.error('MSAL initialization error:', error);
    });
    console.log('MSAL instance created:');
    msalInstance.setNavigationClient(new NavigationAuthenticationClient(msalInstance));
    console.log('setNavigationClient');
    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Optional - This will update account state if a user signs in from another tab or window
    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event) => {
        console.log('MSAL event received:', JSON.stringify(event));
        if ((event.eventType === EventType.LOGIN_SUCCESS  || event.eventType === EventType.SSO_SILENT_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) && event.payload.account) {
            const account = event.payload.account;
            msalInstance.setActiveAccount(account);
        }
    });



    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(<App pca={msalInstance} />);

});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
